/**
 * Drive 协作空间列表项
 */

export var COLLABORATION_SPACE_KIND = 'drive#collaboration-space';
export function isCollaborationSpace(node) {
  return node.kind === COLLABORATION_SPACE_KIND;
}
//# sourceMappingURL=collaboration-space.js.map